"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _ChevronLeft = _interopRequireDefault(require("@material-ui/icons/ChevronLeft"));
var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));
var _styles = require("@material-ui/core/styles");
require("@proofpoint/react-dates/initialize");
require("@proofpoint/react-dates/lib/css/_datepicker.css");
var _react = _interopRequireDefault(require("react"));
var _DayPickerPhrases = _interopRequireDefault(require("./DayPickerPhrases"));
var _colors = require("../colors");
var _Typography = _interopRequireDefault(require("../../components/Typography/Typography"));
var _excluded = ["classes"];
var dayCircleSize = 44;

/* eslint-disable sort-keys */
var styles = function styles(theme) {
  var _root;
  return {
    monthElement: {
      fontWeight: 500
    },
    navNext: {
      color: theme.palette.common.black,
      position: 'absolute',
      right: theme.spacing(2),
      top: theme.spacing(1)
    },
    navPrev: {
      color: theme.palette.common.black,
      left: theme.spacing(2),
      position: 'absolute',
      top: theme.spacing(1)
    },
    root: (_root = {
      '& .CalendarMonth_caption': {
        paddingBottom: 50,
        paddingTop: 10
      },
      '& .DayPicker_weekHeader': {
        top: 40
      },
      '& .DayPicker_weekHeader_ul': {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        margin: 0
      },
      '& .DayPicker_weekHeader_li': {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        height: 40,
        justifyContent: 'center',
        width: dayCircleSize
      },
      '& .DayPicker_weekHeader_li > small': {
        color: _colors.opacity.black[60],
        fontFamily: theme.typography.fontFamily,
        fontSize: 13,
        lineHeight: '20px'
      },
      '& .CalendarDay': {
        border: 'none',
        position: 'relative'
      },
      '& .CalendarDay:hover': {
        border: 'none'
      },
      '& .CalendarDay > p': {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        justifyContent: 'center',
        left: 0,
        position: 'absolute',
        top: 0,
        width: '100%'
      },
      '& .CalendarDay__today > p': {
        border: "2px solid ".concat(_colors.opacity.black[60]),
        borderRadius: dayCircleSize / 2
      },
      '& .CalendarDay__default': {
        background: 'transparent'
      },
      '& .CalendarDay__default:hover': {
        background: 'transparent'
      },
      '& .CalendarDay__default:hover > p': {
        background: theme.palette.common.white,
        border: "2px solid ".concat(theme.palette.primary.main),
        borderRadius: dayCircleSize / 2,
        color: _colors.opacity.black[87]
      },
      '& .CalendarDay__selected:active, & .CalendarDay__selected_span:active': {
        border: 'none'
      },
      '& .CalendarDay__selected > p': {
        background: theme.palette.primary.main,
        border: 'none',
        borderRadius: dayCircleSize / 2,
        color: theme.palette.common.white
      }
    }, (0, _defineProperty2["default"])(_root, "& .CalendarDay__hovered_span,\n      & .CalendarDay__selected_span,\n      & .CalendarDay__selected_span:active,\n      & .CalendarDay__selected_span:hover", {
      background: _colors.opacity.primary[800][8]
    }), (0, _defineProperty2["default"])(_root, "& .CalendarDay__hovered_span_left,\n      & .CalendarDay__hovered_span_left:hover,\n      & .CalendarDay__selected_span_left,\n      & .CalendarDay__selected_span_left:active,\n      & .CalendarDay__selected_span_left:hover", {
      background: "\n      linear-gradient(90deg, ".concat(_colors.opacity.primary[800][8], " 50%, transparent 50%)\n      ")
    }), (0, _defineProperty2["default"])(_root, "& .CalendarDay__hovered_span_right,\n      & .CalendarDay__hovered_span_right:hover,\n      & .CalendarDay__selected_span_right,\n      & .CalendarDay__selected_span_right:active,\n      & .CalendarDay__selected_span_right:hover", {
      background: "\n      linear-gradient(90deg, transparent 50%, ".concat(_colors.opacity.primary[800][8], " 50%)\n      ")
    }), (0, _defineProperty2["default"])(_root, '& .CalendarDay__blocked_out_of_range > p', {
      color: _colors.opacity.black[38]
    }), (0, _defineProperty2["default"])(_root, '& .CalendarDay__blocked_out_of_range:hover > p', {
      border: 'none',
      color: _colors.opacity.black[38]
    }), _root)
  };
};
function withReactDatesStyles(WrappedComponent) {
  /* eslint-disable react/prop-types */
  function WithReactDatesStyles(_ref) {
    var classes = _ref.classes,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    function renderDayContents(day) {
      return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body1"
      }, day.format('D'));
    }
    function renderMonthElement(renderMonthElementProps) {
      return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: classes.monthElement,
        variant: "body1"
      }, renderMonthElementProps.month.format('MMMM YYYY'));
    }
    return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({
      classes: {
        root: classes.root
      },
      daySize: dayCircleSize,
      hideKeyboardShortcutsPanel: true,
      horizontalMonthPadding: 12,
      navNext: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], {
        className: classes.navNext
      }),
      navPrev: /*#__PURE__*/_react["default"].createElement(_ChevronLeft["default"], {
        className: classes.navPrev
      }),
      noBorder: true,
      phrases: _DayPickerPhrases["default"],
      renderDayContents: renderDayContents,
      renderMonthElement: renderMonthElement,
      verticalBorderSpacing: 4
    }, props));
  }
  /* eslint-disable react/prop-types */
  return (0, _styles.withStyles)(styles)(WithReactDatesStyles);
}
var _default = withReactDatesStyles;
exports["default"] = _default;